import type { ConcreteAccount } from '@thinkalpha/trading-ws-client/contracts/account.js';
import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'getPreferredAccountId' });

export function getPreferredAccountId(
    userId: string | undefined,
    availableAccounts: ConcreteAccount[],
    preferredAccountsMap: ReadonlyMap<string, string>,
): string | undefined {
    if (availableAccounts.length === 0) return undefined;

    if (userId) {
        const preferredAccountId = preferredAccountsMap.get(userId);
        if (preferredAccountId && availableAccounts.some((a) => a.id === preferredAccountId)) {
            if (TRACE) {
                log.trace('Resolved preferred account', { userId, preferredAccountId });
            }
            return preferredAccountId;
        }
    }

    if (TRACE) {
        log.trace('Falling back to first available account', { userId, accountId: availableAccounts[0].id });
    }
    return availableAccounts[0].id;
}
